<div class="vertical-title">
  <div class="vertical-title__title">{{title}}</div>
  <div class="vertical-title__sub-title">{{subTitle}}</div>
</div>
